import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ScrollToTop } from "@/components/ScrollToTop";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Oferta from "@/pages/subpages/Oferta";
import Szkolenia from "@/pages/subpages/Szkolenia";
import DlaAgencji from "@/pages/subpages/DlaAgencji";
import Kontakt from "@/pages/subpages/Kontakt";
import Polityka from "@/pages/subpages/Polityka";
import Regulamin from "@/pages/subpages/Regulamin";
import Apm from "@/pages/Apm";
import ApmHistoria from "@/pages/ApmHistoria";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/oferta" element={<Oferta />} />
          <Route path="/szkolenia" element={<Szkolenia />} />
          <Route path="/dla-agencji" element={<DlaAgencji />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/polityka-prywatnosci" element={<Polityka />} />
          <Route path="/regulamin" element={<Regulamin />} />
          <Route path="/apm" element={<Apm />} />
          <Route path="/apm/moja-historia" element={<ApmHistoria />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
